@if (isLoggedIn$ | async) {
    <nav class="navbar navbar-dark bg-dark" [ngClass]="{ impersonating: impersonating$ | async }">
        <a class="navbar-brand" href="javascript:void(0)">
            @if (navigationVisible) {
                <button type="button" class="btn btn-link btn-nav-toggle" (click)="toggleNav()">
                    <fa-icon class="expand-icon" icon="bars" size="lg"></fa-icon>
                </button>
            }
            <img width="124" alt="ZEN Master logo" class="align-middle" (click)="goToHome()" [src]="appService.whiteLogoUrl" />
        </a>
        <zx-breadcrumbs class="d-none d-md-flex" [ngClass]="{ 'ms-0': (isNavExpanded$ | async) === false }"></zx-breadcrumbs>
        @if (impersonating$ | async) {
            <span class="white ms-auto me-2"
                ><fa-icon icon="user-secret" size="1x"></fa-icon><span class="d-none d-md-inline-block ms-1">{{ "IMPERSONATING" | translate }}</span
                ><span class="ms-1">-&nbsp;{{ dnsPrefix$ | async }}</span
                ><a class="ms-1" href="/api/impersonate/zixi"><fa-icon icon="times-circle" size="1x"></fa-icon></a
            ></span>
        }
        <!-- Timezone -->
        <app-time-settings class="d-flex align-items-center ms-auto"></app-time-settings>
        <!-- User -->
        <button type="button" class="d-none d-xs-flex btn btn-link navbar-text" (click)="myAccount()">
            <fa-icon icon="user"></fa-icon>
            <span class="d-none d-lg-inline-block ms-1">{{ userName$ | async }}</span>
        </button>
        <!-- Help -->
        <div ngbDropdown display="dynamic" class="d-none d-xs-flex">
            <button class="btn btn-link p-0 pe-2 ps-1" id="sortByDropdown" ngbDropdownToggle title="{{ 'HELP' | translate }}">
                <fa-icon icon="question-circle" size="1x"></fa-icon>
                <span class="d-none d-lg-inline-block ms-1">{{ "HELP" | translate }}</span>
            </button>
            <div ngbDropdownMenu aria-labelledby="sortByDropdown" class="shadow-sm">
                <h5 class="dropdown-item-text">{{ "HELP_MENU.DOCUMENTATION" | translate }}</h5>
                <button class="text-primary" ngbDropdownItem (click)="help()">
                    {{ "USER_GUIDE" | translate }}
                </button>
                @for (helpConfig of helpConfigs; track helpConfig) {
                    <button class="text-primary" ngbDropdownItem (click)="help(helpConfig.link)">
                        {{ helpConfig.menu | translate }}
                    </button>
                }
                <h5 class="dropdown-item-text">{{ "HELP_MENU.HELP_US" | translate }}</h5>
                <button class="text-primary" ngbDropdownItem (click)="reportIssue()">
                    {{ "REPORT_ISSUE" | translate }}
                </button>
            </div>
        </div>
        <!-- Dark Mode -->
        <button type="button" class="d-none d-xxs-flex btn btn-outline-secondary darkmode-button" (click)="toggleDarkMode()">
            @if (!isDarkMode) {
                <fa-icon icon="moon" size="sm"></fa-icon>
            }
            @if (isDarkMode) {
                <fa-icon icon="sun" size="sm"></fa-icon>
            }
            @if (!isDarkMode) {
                <span class="sr-only">{{ "DARK_MODE" | translate }}</span>
            }
            @if (isDarkMode) {
                <span class="sr-only">{{ "LIGHT_MODE" | translate }}</span>
            }
        </button>
        <button data-zm="logout-button" type="button" class="btn btn-outline-navbar logout-button" (click)="logout()" title="{{ 'LOGOUT' | translate }}">
            <fa-icon icon="sign-out-alt"></fa-icon>
            <span class="d-none d-lg-inline-block ms-1">{{ "LOGOUT" | translate }}</span>
        </button>
    </nav>
}
